<lib-select
  [style.height.%]="100"
  [options]="(serviceCenterOptions$ | async) ?? []"
  [formControl]="controlEntity"
  [labelTranslateKey]="labelTranslateKey"
  [searchTranslateKey]="searchTranslateKey"
  [isClearable]="isClearable"
  [fullWidth]="fullWidth"
  [isSearchDisplayed]="true"
  [isOptionListLoading]="serviceCenterDictionaryService.loadingState() === LoadingState.LOADING"
  (scrolled)="loadMore()"
  (searchKeyChange)="onKeywordChange($event)"
/>
